import { render, staticRenderFns } from "./PublisherDashboardMetrics.vue?vue&type=template&id=aa1c2594&"
import script from "./PublisherDashboardMetrics.vue?vue&type=script&lang=js&"
export * from "./PublisherDashboardMetrics.vue?vue&type=script&lang=js&"
import style0 from "./PublisherDashboardMetrics.vue?vue&type=style&index=0&id=aa1c2594&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports